export default __webpack_public_path__ + "static/media/question-mark-active-tournament.98193bf3.svg";